import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  SHOW_MESSAGE_SUCCESS,
  USER_LOGOUT_SUCCESS,
  FALSE_SHOW_MESSAGE,
} from "../actionTypes";

const istate = {
  fetchingUserLogin: false,
  fetchedUserLogin: false,
  message: "",
  statusCode: "",
  showMessage: false,
  data: "",
  userLoginError: "",
};

export default function userLoginReducer(state = istate, action) {
  switch (action.type) {
    case USER_LOGIN: {
      return {
        ...state,
        fetchingUserLogin: true,
        fetchedUserLogin: false,
      };
    }
    case USER_LOGIN_SUCCESS: {
      return {
        ...state,
        fetchingUserLogin: false,
        fetchedUserLogin: true,
        showMessage: true,
        data: action.payload.body.data,
        // message: action.payload.body.statusOfRequest.message,
        message: "Logged In Successfully",
        statusCode: action.payload.body.statusOfRequest.statusCode,
      };
    }
    case USER_LOGOUT_SUCCESS: {
      return {
        ...state,
        statusCode: action.payload,
        showMessage: false,
      };
    }

    case USER_LOGIN_FAILURE: {
      return {
        ...state,
        fetchedUserLogin: false,
        statusCode: 1,
        userLoginError: action.payload,
        showMessage: true,
        message: action.payload,
      };
    }
    case SHOW_MESSAGE_SUCCESS: {
      return {
        ...state,
        showMessage: true,
      };
    }
    case FALSE_SHOW_MESSAGE: {
      return {
        ...state,
        showMessage: false,
        message: "",
      };
    }
    default:
      return state;
  }
}
